module.exports = "//cdn.mxpnl.com/static/asset-cache/b9dd2ee86332cca6e0099edbb13688d9/iron/common/assets/images/charts/pie.svg";